import axios from 'axios';
import { userBooksAction } from './UserBooksSlice';

const getUserBooks = (token) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_DEV_URI}/user/books`;
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.get(url, { headers });
      return response;
    };
    try {
      const result = await fetchData();
      dispatch(userBooksAction.userBooksSuccess(result.data));
      return result.data;
    } catch (e) {
      dispatch(userBooksAction.userBooksFailure(e.response?.data ?? e.message));
      return null
    }
  };
};

export default getUserBooks;